import React, { useEffect, useRef } from "react";
import { Formik, Field } from "formik";
import Input from "../../../ui/Input";
import Form, { InputSection } from "../components/Form";
import * as yup from "yup";
import { putEndpoint } from "../../../api/api";
import { get } from "../../../utils/get";
import { USER_URL } from "../../../api/urls";
import { toast } from "react-toastify";

const PasswordUpdateSchema = yup.object().shape({
  password: yup
    .string()
    .label("Password")
    .required()
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, at least: One Uppercase, One Lowercase, One Number and one special case Character"
    ),
    // .min(2, "password too short...")
    // .max(10, "Your password must be a maximum of 10 characters."),
  confirm_password: yup
    .string()
    .required()
    .label("Confirm password")
    .oneOf([yup.ref("password")], "Passwords must match"),
});

interface IProps {
  setHandleSubmit?: any;
  setHandleDisable?:any;
  closeModal?: any;
  id: string;
}

const PasswordUpdate = ({ setHandleSubmit, closeModal,setHandleDisable, id }: IProps) => {
  const [updateRes, updateReq] = putEndpoint();
  const formRef: any = useRef<any>(null);

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, []);

  useEffect(() => {
    const { complete, pending, data, error } = updateRes;
    if (error) toast.error(get(data, "message"));
    if (!pending && complete && !error) {
      toast.success("Password updated successfully");
      closeModal();
    }
  }, [closeModal, updateRes]);

  const handlePasswordUpdate = (values) => {
    setHandleDisable(true)
    const payload = {
      password: get(values, "password"),
    };
    updateReq(`${USER_URL}/${id}`, payload);
  };

  return (
    <Formik
      innerRef={formRef}
      validationSchema={PasswordUpdateSchema}
      initialValues={{ passowrd: "", confirm_password: "" }}
      onSubmit={handlePasswordUpdate}
    >
      {() => (
        <Form>
          <InputSection>
            <Field
              type="password"
              name="password"
              component={Input}
              label="Password"
              // width="47%"
            />
          </InputSection>
          <InputSection>
            <Field
              type="password"
              name="confirm_password"
              component={Input}
              label=" Confirm Password"
            />
          </InputSection>
        </Form>
      )}
    </Formik>
  );
};

export default PasswordUpdate;
